// Copyright 2020 the .NET Foundation
// Licensed under the MIT License
import { __read, __values } from "tslib";
import { enumLookup } from "@wwtelescope/engine-types";
export var PlanetaryBodies;
(function (PlanetaryBodies) {
    PlanetaryBodies["Sun"] = "sun";
    PlanetaryBodies["Mercury"] = "mercury";
    PlanetaryBodies["Venus"] = "venus";
    PlanetaryBodies["Earth"] = "earth";
    PlanetaryBodies["Mars"] = "mars";
    PlanetaryBodies["Jupiter"] = "jupiter";
    PlanetaryBodies["Saturn"] = "saturn";
    PlanetaryBodies["Uranus"] = "uranus";
    PlanetaryBodies["Neptune"] = "neptune";
    PlanetaryBodies["Pluto"] = "pluto";
    PlanetaryBodies["Moon"] = "moon";
    PlanetaryBodies["Io"] = "io";
    PlanetaryBodies["Europa"] = "europa";
    PlanetaryBodies["Ganymede"] = "ganymede";
    PlanetaryBodies["Callisto"] = "callisto";
})(PlanetaryBodies || (PlanetaryBodies = {}));
export var CreditMode;
(function (CreditMode) {
    CreditMode["Default"] = "default";
    CreditMode["None"] = "no";
})(CreditMode || (CreditMode = {}));
var EmbedSettings = /** @class */ (function () {
    function EmbedSettings() {
        this.backgroundImagesetName = "";
        this.foregroundImagesetName = "";
        this.creditMode = CreditMode.Default;
        this.showCoordinateReadout = false;
        this.showCrosshairs = false;
        this.tourUrl = "";
        this.wtmlUrl = "";
        this.wtmlPlace = "";
    }
    EmbedSettings.fromQueryParams = function (qp) {
        var e_1, _a;
        var s = new EmbedSettings();
        try {
            for (var qp_1 = __values(qp), qp_1_1 = qp_1.next(); !qp_1_1.done; qp_1_1 = qp_1.next()) {
                var _b = __read(qp_1_1.value, 2), key = _b[0], value = _b[1];
                switch (key) {
                    case "bg":
                        s.backgroundImagesetName = value;
                        break;
                    case "ch":
                        s.showCrosshairs = true;
                        break;
                    case "cro":
                        s.showCoordinateReadout = true;
                        break;
                    case "cred":
                        {
                            var m = enumLookup(CreditMode, value);
                            if (m !== undefined)
                                s.creditMode = m;
                        }
                        break;
                    case "fg":
                        s.foregroundImagesetName = value;
                        break;
                    case "p":
                        s.wtmlPlace = value;
                        break;
                    case "planet":
                        if (value == "mars") {
                            // Gnarly historical thing that the default Mars imageset
                            // is named thusly:
                            s.backgroundImagesetName = "Visible Imagery";
                            s.foregroundImagesetName = "Visible Imagery";
                        }
                        else if (value == "earth") {
                            s.backgroundImagesetName = "Bing Maps Aerial";
                            s.foregroundImagesetName = "Bing Maps Aerial";
                        }
                        else if (value == "pluto") {
                            s.backgroundImagesetName = "Pluto (New Horizons)";
                            s.foregroundImagesetName = "Pluto (New Horizons)";
                        }
                        else {
                            s.backgroundImagesetName = value;
                            s.foregroundImagesetName = value;
                        }
                        break;
                    case "threed":
                        s.backgroundImagesetName = "3D Solar System View";
                        s.foregroundImagesetName = "";
                        break;
                    case "tour":
                        s.tourUrl = value;
                        break;
                    case "wtml":
                        s.wtmlUrl = value;
                        break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (qp_1_1 && !qp_1_1.done && (_a = qp_1.return)) _a.call(qp_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return s;
    };
    EmbedSettings.prototype.asSettings = function () {
        var s = [];
        s.push(["showCrosshairs", this.showCrosshairs]);
        return s;
    };
    return EmbedSettings;
}());
export { EmbedSettings };
/** A class to help building query strings that get parsed into EmbedSettings
 * objects. There are a few shorthands for setups where the "implementation
 * details" are a bit weird or might change.
 */
var EmbedQueryStringBuilder = /** @class */ (function () {
    function EmbedQueryStringBuilder() {
        this.s = new EmbedSettings();
        this.threeDMode = false;
        this.planetaryBody = null;
    }
    EmbedQueryStringBuilder.prototype.toQueryItems = function () {
        var result = [];
        var defaults = new EmbedSettings();
        if (this.threeDMode) {
            result.push(["threed", ""]);
        }
        else if (this.planetaryBody !== null) {
            result.push(["planet", this.planetaryBody]);
        }
        else {
            if (this.s.backgroundImagesetName.length && this.s.backgroundImagesetName != defaults.backgroundImagesetName)
                result.push(["bg", this.s.backgroundImagesetName]);
            if (this.s.foregroundImagesetName.length && this.s.foregroundImagesetName != defaults.foregroundImagesetName)
                result.push(["fg", this.s.foregroundImagesetName]);
        }
        if (this.s.creditMode && this.s.creditMode != CreditMode.Default) {
            result.push(["cred", this.s.creditMode]);
        }
        if (this.s.showCoordinateReadout) {
            result.push(["cro", ""]);
        }
        if (this.s.showCrosshairs) {
            result.push(["ch", ""]);
        }
        if (this.s.tourUrl.length) {
            result.push(["tour", this.s.tourUrl]);
        }
        if (this.s.wtmlPlace.length) {
            result.push(["p", this.s.wtmlPlace]);
        }
        if (this.s.wtmlUrl.length) {
            result.push(["wtml", this.s.wtmlUrl]);
        }
        return result;
    };
    return EmbedQueryStringBuilder;
}());
export { EmbedQueryStringBuilder };
//# sourceMappingURL=index.js.map